import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import fr from "@angular/common/locales/fr";
import en from "@angular/common/locales/en-GB";
import { registerLocaleData } from "@angular/common";

@Component({
    selector: "app-root",
    template: "<router-outlet></router-outlet>",
    styleUrls: ["./block.scss"],
})
export class AppComponent implements OnInit {
    private availableLanguages = ["fr", "en"];

    constructor(private translate: TranslateService) {}

    ngOnInit() {
        registerLocaleData(fr, "fr");
        registerLocaleData(en, "en");
        let browserLang = navigator.language;
        // console.log("Browser Lang", browserLang);
        if (browserLang.includes("-")) {
            [browserLang] = browserLang.split("-");
        }
        console.log("Browser Lang", browserLang);
        if (this.availableLanguages.includes(browserLang)) {
            this.translate.setDefaultLang(`_${browserLang}`);
        } else {
            this.translate.setDefaultLang(`_en`);
        }
    }
}
